import { PreviewFileProps } from './Types'
import Styles from './MediaFromLinkDrawer.module.scss'
import { Button } from 'blaze-ui/Button'
import { Input } from 'almanac-ui/TextInputField/Input'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { isVideo } from 'components/ImagePickerModal/utils'

export const PreviewFile = observer(({ file, url, onUse }: PreviewFileProps) => {
  const { drawersStore } = useRootStore()
  const video = isVideo({ url, type: file.type })
  const fileUrl = URL.createObjectURL(file)
  const mediaType = video ? 'Video' : 'Image'

  const onConfirm = () => {
    onUse(file)
    drawersStore.closeDrawer()
  }

  return (
    <>
      {video ? (
        <video src={fileUrl} autoPlay loop controls className={Styles.mediaPreview} data-testid="video-preview" />
      ) : (
        <img src={fileUrl} alt="Media from URL" className={Styles.mediaPreview} />
      )}
      <div className={Styles.actions}>
        <Input name="Chosen URL" variant="grey" size="lg" value={url} autoComplete="off" disabled />
        <Button aria-label="Submit" variant="primary" size="lg" onPress={onConfirm} fullWidth>
          Use {mediaType}
        </Button>
      </div>
    </>
  )
})
